var path = 'components/json-content.tpl.html';
var html = " <div style=background:#fff tk-expand-fullscreen fullscreen-zindex=100 expand-button-id=expand-button on-fullscreen-changed=onFullscreenChanged() layout=column> <div layout=row layout-align=\"start center\"> <label class=\"tk-title no-padding\">{{ label }}</label> <span flex></span> <md-button id=expand-button aria-label=Fullscreen class=\"md-icon-button tk-md-32 tk-fullscreen-button-style\"></md-button> </div> <div id=tk-json-panel class=tk-json-content-panel layout=column> <div id=tk-json-input ng-readonly=readonly ui-ace=jsonEditorOptions ng-model=contentBody> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/json-content.tpl.html
// module id = 1480
// module chunks = 1